export enum AreaUnit {
	SquareFeet = "squareFeet",
	SquareMeters = "squareMeters",
}

export enum DistanceUnit {
	Feet = "feet",
	Meters = "meters",
}

const squareMetersPerSquareFoot = 0.09290304
const metersPerFoot = 0.3048

export function convertArea(value: number, sourceUnit: AreaUnit, targetUnit: AreaUnit): number {
	if (sourceUnit === targetUnit) {
		return value
	}

	if (sourceUnit === AreaUnit.SquareFeet) {
		return value * squareMetersPerSquareFoot
	}

	return value / squareMetersPerSquareFoot
}

export function convertAreaRange<T extends readonly number[]>(
	values: T,
	sourceUnit: AreaUnit,
	targetUnit: AreaUnit
): T {
	return values.map(value => convertArea(value, sourceUnit, targetUnit)) as unknown as T
}

export function convertDistance(value: number, sourceUnit: DistanceUnit, targetUnit: DistanceUnit): number {
	if (sourceUnit === targetUnit) {
		return value
	}

	if (sourceUnit === DistanceUnit.Feet) {
		return value * metersPerFoot
	}

	return value / metersPerFoot
}

export function convertPricePerArea(value: number, sourceUnit: AreaUnit, targetUnit: AreaUnit): number {
	if (sourceUnit === targetUnit) {
		return value
	}

	if (sourceUnit === AreaUnit.SquareFeet) {
		return value / squareMetersPerSquareFoot
	}

	return value * squareMetersPerSquareFoot
}
